import type { LearnTopic } from '../types';
import { $, $0 } from '../format';

export const whatIsAnOptionTopic: LearnTopic = {
  id: 'what-is-an-option',
  tier: 'basics',
  title: 'What an option is',
  summary:
    'A contract, not something you own: one side buys a right, the other takes on an obligation, and it all runs out on a date.',
  body: [
    'An option is a contract, not a thing you own. Picture paying a dealer a fee to hold a car at today\'s price until Friday. The fee buys you the right to come back and buy at that price. It does not buy you the car, and if you never come back, the right is all you ever had.',
    'One side of every option has a right; the other side has an obligation. The buyer may act and does not have to. The seller must act if the buyer does. Everything else in these pages is built on that one sentence — which side of it you are on decides what you can make and what you can lose.',
    'The fee has a name: the premium, the price of the contract. It is spent either way. It is not refunded if you walk away, and it is not credited against the purchase if you go through with it. When you sell an option, that premium is yours from the moment the trade fills, and it is the whole of what you are paid.',
    'A deadline is part of the contract. On the expiration date the right simply ends, used or not. That deadline is what makes selling options a business rather than a bet on direction: time runs one way, and every day that passes takes a little value out of the contract you sold.',
    "Options are quoted per share but traded in contracts, and one contract is 100 shares. The premium you are paid for selling is called a credit — money paid to you, not owed — and a credit of $1.50 a share is $150 for one contract. Steward shows both figures for that reason — per share to compare trades, per contract for what actually moved through your account. The buyers-and-sellers examples and the lessons behind them are Howard's.",
  ],
  explain(ctx) {
    const { symbol, credit } = ctx;
    return [
      `One ${symbol} contract here is 100 shares, so every per-share figure on this position is 100 times that per contract.`,
      credit != null
        ? `You collected ${$(credit)} a share on this position, which is ${$0(credit * 100)} per contract.`
        : 'Right now no credit is recorded for this position, so there is nothing to multiply out per contract.',
    ];
  },
  appliesTo() {
    return true;
  },
};
